import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';

import { ApiStatusCodes } from '../../../services/api/apiStatusCode';
import { userEndpoints } from '../../../services/api/endPoints';
import { HTTPClient } from '../../../services/api/http-client';
import {
  fetchUserPermission,
  fetchUserPermissionFailed,
  fetchUserPermissionPlatform,
  fetchUserPermissionSucceeded,
} from '../../slice/user/UserPermission.slice';
import { IUserPermissionParam } from './User.types';

export interface IPermission {
  entityId: string;
}

export function* fetchUserPermissionSaga() {
  try {
    // Simulate API call with a 10-second delay using Redux Saga's `delay` effect
    const result: AxiosResponse<IUserPermissionParam> =
      yield HTTPClient.GetRequest(userEndpoints.GET_USER_PERMISSION);

    const { data, status } = result;

    if (status === ApiStatusCodes.SUCCESS && data) {
      yield put(fetchUserPermissionSucceeded(data));
    } else {
      fetchUserPermissionFailed({
        error: {
          message: 'An error occurred while fetching user permissions.',
        },
      });
      throw new Error();
    }
  } catch (error) {
    // Handle API call failure or network errors
    yield put(
      fetchUserPermissionFailed({
        error: {
          message: 'An error occurred while fetching user permissions.',
        },
      })
    );
  }
}

export function* fetchUserPermissionPlatformSaga(
  action: PayloadAction<IPermission>
) {
  try {
    const { entityId } = action.payload;
    // Simulate API call with a 10-second delay using Redux Saga's `delay` effect
    const result: AxiosResponse<IUserPermissionParam> =
      yield HTTPClient.GetRequest(userEndpoints.GET_USER_PERMISSION1(entityId));

    const { data, status } = result;

    if (status === ApiStatusCodes.SUCCESS && data) {
      yield put(fetchUserPermissionSucceeded(data));
    } else {
      fetchUserPermissionFailed({
        error: {
          message: 'An error occurred while fetching user permissions.',
        },
      });
      // throw new Error();
    }
  } catch (error) {
    // Handle API call failure or network errors
    yield put(
      fetchUserPermissionFailed({
        error: {
          message: 'An error occurred while fetching user permissions.',
        },
      })
    );
  }
}

export function* watchUserPermissionSaga() {
  yield takeLatest(fetchUserPermission.type, fetchUserPermissionSaga);
  yield takeLatest(
    fetchUserPermissionPlatform.type,
    fetchUserPermissionPlatformSaga
  );
}
